import { render, staticRenderFns } from "./organisationSettings.vue?vue&type=template&id=aacff88c&"
import script from "./organisationSettings.vue?vue&type=script&lang=js&"
export * from "./organisationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports